import { Heading } from '@zillow/constellation-10';

import { css } from '@/styled-system/css';
import { shimmerStyles } from '../styles/ShimmerStyles';

import type { HeadingPropsInterface } from '@zillow/constellation-10';

export const LoadingHeading = ({
  isLoading,
  loadingWidth,
  children,
  css: cssProp,
  style: styleProp,
  ...rest
}: {
  isLoading: boolean;
  loadingWidth?: string;
} & Omit<HeadingPropsInterface, 'ref'>) => (
  <Heading
    data-loading={isLoading || null}
    css={css.raw(cssProp, shimmerStyles)}
    style={isLoading ? { width: loadingWidth ? loadingWidth : '100%', ...styleProp } : { ...styleProp }}
    {...rest}
  >
    {isLoading ? <span aria-hidden="true">&nbsp;</span> : children}
  </Heading>
);
